import z from 'zod';
export const invoiceIdValue = z.string().brand('InvoiceId');
export const createInvoiceId = (value) => invoiceIdValue.parse(value);
export const isInvoiceId = (value) => invoiceIdValue.safeParse(value).success;
//# sourceMappingURL=invoice-id.js.map